import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {APIService} from "@shared/api.service";
import {MailInviateSingle} from "@models/MailInviateSingle.model";

export const mailArchiveSingleResolver: ResolveFn<MailInviateSingle> = (route, state) => {

  const apiService = inject(APIService);
  return apiService.get('customerinfodigests',route.params['id']);
};
